module.exports = __webpack_public_path__ + "static/media/combo-pate-xuc-xich.71e3a6f9.jpg";